import { createApp } from 'vue'
import App from '@/App.vue'
import { registerPlugins } from '@core/utils/plugins'

import Toast, { POSITION } from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import 'vue-multiselect/dist/vue-multiselect.css'

import { ability } from './plugins/casl/ability'
import { abilitiesPlugin } from '@casl/vue'
import { initAbilityFromStorage } from './plugins/casl/initCasl'
import { initPwa } from '@/pwa'

// Styles
import '@core-scss/template/index.scss'
import '@styles/styles.scss'

// Initialize ability from localStorage before app starts
initAbilityFromStorage()

document.addEventListener('wheel', event => {
  const target = event.target

  if (target instanceof HTMLInputElement && target.type === 'number')
    target.blur()
}, { capture: true })

document.addEventListener('keydown', event => {
  const target = event.target

  if (target instanceof HTMLInputElement && target.type === 'number' && ['ArrowUp', 'ArrowDown'].includes(event.key))
    event.preventDefault()
})

// Right click on any internal link opens it in a new tab (left click stays in the same tab)
document.addEventListener('contextmenu', event => {
  const link = event.target instanceof Element ? event.target.closest('a[href]') : null
  if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self'))
    return

  const url = new URL(link.href, window.location.href)
  if (!['http:', 'https:'].includes(url.protocol) || url.origin !== window.location.origin)
    return

  // Same-page anchors (e.g. "#") are not navigation links
  if (url.pathname === window.location.pathname && url.search === window.location.search)
    return

  event.preventDefault()
  window.open(url.href, '_blank')
})

// Create app
const app = createApp(App)

// ✅ Register plugins one by one
app.use(Toast, {
  position: POSITION.TOP_RIGHT,
  timeout: 3000,
  hideProgressBar: false,
  padding: '10px',
})


app.use(abilitiesPlugin, ability) // ✅ CASL plugin properly registered

// Register your custom plugins
registerPlugins(app)

// Global error handler
window.addEventListener('unhandledrejection', event => {
  console.error('UNHANDLED PROMISE ERROR:', event.reason)
})

// Mount
app.mount('#app')

// PWA: service worker, install prompt, update + offline detection
initPwa()
